var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPuzzle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 3a1.5 1.5 0 0 0-1.5 1.5V6H8.75A1.75 1.75 0 0 0 7 7.75V11H5.5a1.5 1.5 0 1 0 0 3H7v3.25C7 18.216 7.784 19 8.75 19H12v-1.5a1.5 1.5 0 1 1 3 0V19h3.25A1.75 1.75 0 0 0 20 17.25V13h-1.5a1.5 1.5 0 1 1 0-3H20V7.75A1.75 1.75 0 0 0 18.25 6H16V4.5A1.5 1.5 0 0 0 14.5 3Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPuzzle);
export default __webpack_public_path__ + "static/media/puzzle.36e3b01579b819f274436fc8d0821fa2.svg";
export { ForwardRef as ReactComponent };